<div class="leads-page p-fluid">
    <app-page-shell>
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


    <app-page-hero eyebrow="CRM Pipeline" title="Leads" subtitle="Capture early customer intake, qualify opportunities, and hand clean data into client conversion.">
        <div actions>
            <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadLeads()"></p-button>
            <p-button label="Duplicates" icon="pi pi-clone" severity="secondary" [outlined]="true" (click)="loadDuplicates()"></p-button>
            <p-button label="New Lead" icon="pi pi-plus" (click)="openNew()"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-search-panel title="Search Leads" [activeFilters]="activeSearchCount" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
        <div class="search-grid">
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadGlobalSearch" pInputText [ngModel]="searchText()" (ngModelChange)="setSearchText($event)" (keydown.enter)="applySearch()">
                        <label for="leadGlobalSearch">Global Search</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadNumberSearch" pInputText [ngModel]="columnFilters()['leadNumber'] || ''" (ngModelChange)="setColumnFilter('leadNumber', $event)" (keydown.enter)="applySearch()">
                        <label for="leadNumberSearch">Lead #</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadCompanySearch" pInputText [ngModel]="columnFilters()['companyName'] || ''" (ngModelChange)="setColumnFilter('companyName', $event)" (keydown.enter)="applySearch()">
                        <label for="leadCompanySearch">Company</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadContactSearch" pInputText [ngModel]="columnFilters()['pocName'] || ''" (ngModelChange)="setColumnFilter('pocName', $event)" (keydown.enter)="applySearch()">
                        <label for="leadContactSearch">Contact Person</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadEmailSearch" pInputText [ngModel]="columnFilters()['pocEmail'] || ''" (ngModelChange)="setColumnFilter('pocEmail', $event)" (keydown.enter)="applySearch()">
                        <label for="leadEmailSearch">Email</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadPhoneSearch" pInputText [ngModel]="columnFilters()['pocPhoneNumber'] || ''" (ngModelChange)="setColumnFilter('pocPhoneNumber', $event)" (keydown.enter)="applySearch()">
                        <label for="leadPhoneSearch">Phone</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select inputId="leadStatusSearch" [options]="statuses" optionLabel="label" optionValue="value" [ngModel]="statusFilter()" (ngModelChange)="setStatusFilter($event)" [showClear]="true" styleClass="w-full"></p-select>
                        <label for="leadStatusSearch">Status</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-compass"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadSourceSearch" pInputText [ngModel]="sourceFilter()" (ngModelChange)="setSourceFilter($event)" (keydown.enter)="applySearch()">
                        <label for="leadSourceSearch">Source</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-star"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <input id="leadQualitySearch" pInputText [ngModel]="columnFilters()['leadQuality'] || ''" (ngModelChange)="setColumnFilter('leadQuality', $event)" (keydown.enter)="applySearch()">
                        <label for="leadQualitySearch">Quality</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field roles-field">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
                    <p-iftaLabel class="chips-ifta-label">
                        <p-multiSelect
                            inputId="leadRoleSearch"
                            [options]="crmRoles()"
                            optionLabel="label"
                            optionValue="value"
                            [ngModel]="roleFilters()"
                            (ngModelChange)="setRoleFilters($event)"
                            display="chip"
                            [filter]="true"
                            [showClear]="true"
                            appendTo="body"
                            styleClass="w-full roles-multiselect">
                        </p-multiSelect>
                        <label for="leadRoleSearch">Business Roles</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-data-panel title="Lead Directory" [subtitle]="lastUpdatedText" [resultText]="leads().length + ' of ' + totalRecords() + ' records'">
        <p-table
            #dt
            [value]="leads()"
            [rows]="rows()"
            [paginator]="true"
            [tableStyle]="{ 'min-width': '62rem' }"
            [loading]="loading()"
            [rowHover]="true"
            dataKey="id"
            styleClass="p-datatable-sm p-datatable-gridlines leads-data-table"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} leads"
            [showCurrentPageReport]="true"
            [lazy]="true"
            [totalRecords]="totalRecords()"
            (onLazyLoad)="loadLeads($event)">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="leadNumber" style="width: 9rem">Lead <p-sortIcon field="leadNumber"></p-sortIcon></th>
                    <th pSortableColumn="companyName">Company Profile <p-sortIcon field="companyName"></p-sortIcon></th>
                    <th pSortableColumn="pocName">Contact <p-sortIcon field="pocName"></p-sortIcon></th>
                    <th pSortableColumn="leadQuality">Qualification <p-sortIcon field="leadQuality"></p-sortIcon></th>
                    <th>Ownership / Updates</th>
                    <th class="text-center" style="width: 8rem">Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-lead>
                <tr>
                    <td>
                        <div class="stack-cell lead-identity">
                            <span class="code-pill">{{ lead.leadNumber || 'NEW' }}</span>
                            <p-tag [value]="lead.status" [severity]="getSeverity(lead.status)" class="uppercase font-bold"></p-tag>
                        </div>
                    </td>
                    <td>
                        <div class="stack-cell">
                            <a class="link-button cell-title" [routerLink]="['/crm/leads', lead.id]">{{ lead.companyName }}</a>
                            <span class="cell-subtitle" *ngIf="lead.customerNameLocal">{{ lead.customerNameLocal }}</span>
                            <div class="flex flex-wrap gap-1" *ngIf="lead.roles?.length">
                                <p-tag *ngFor="let role of lead.roles" [value]="roleLabel(role)" severity="contrast"></p-tag>
                            </div>
                            <div class="cell-meta">
                                <span><i class="pi pi-briefcase"></i>{{ lead.businessType || 'Business n/a' }}</span>
                                <span><i class="pi pi-map-marker"></i>{{ lead.city || 'City n/a' }}</span>
                                <span><i class="pi pi-compass"></i>{{ lead.source || 'Source n/a' }}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="stack-cell">
                            <span class="cell-title">{{ lead.pocName || '-' }}</span>
                            <div class="cell-meta vertical">
                                <span><i class="pi pi-envelope"></i>{{ lead.pocEmail || '-' }}</span>
                                <span><i class="pi pi-phone"></i>{{ lead.pocPhoneNumber || lead.mobileNumber || '-' }}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="stack-cell">
                            <span class="quality-pill">{{ lead.leadQuality || '-' }}</span>
                            <div class="cell-meta vertical">
                                <span><i class="pi pi-sitemap"></i>{{ lead.natureOfBusiness || 'Nature n/a' }}</span>
                                <span><i class="pi pi-receipt"></i>{{ lead.taxRegNumber || lead.crNumber || 'Compliance n/a' }}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="stack-cell">
                            <span class="cell-title">{{ lead.salesTeamName || lead.kamCustomerId || 'Unassigned' }}</span>
                            <div class="cell-meta vertical">
                                <span><i class="pi pi-user"></i>Created by {{ lead.createdByCustomerName || lead.createdByCustomerId || '-' }}</span>
                                <span><i class="pi pi-clock"></i>{{ lead.updatedAt ? (lead.updatedAt | date:'medium') : 'Not updated' }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="row-actions">
                            <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-text p-button-info" [routerLink]="['/crm/leads', lead.id]" pTooltip="View Details"></button>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="editLead(lead)" pTooltip="Edit"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="deleteLead(lead)" pTooltip="Delete"></button>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="empty-state">
                            <i class="pi pi-search"></i>
                            <strong>No leads found</strong>
                            <span>No matching lead records.</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
    </app-page-shell>
</div>

<p-dialog [(visible)]="duplicateDialog" [modal]="true" [style]="{width: '900px'}" header="Potential Duplicate Leads">
    <p-table [value]="duplicates()" [tableStyle]="{ 'min-width': '60rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Primary</th>
                <th>Duplicate</th>
                <th>Reason</th>
                <th style="width: 10rem">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td>
                    <div class="font-bold">{{ row.primary.companyName }}</div>
                    <div class="text-500 text-sm">{{ row.primary.pocName }} | {{ row.primary.pocEmail }}</div>
                </td>
                <td>
                    <div class="font-bold">{{ row.duplicate.companyName }}</div>
                    <div class="text-500 text-sm">{{ row.duplicate.pocName }} | {{ row.duplicate.pocEmail }}</div>
                </td>
                <td>{{ row.reasons.join(', ') }}</td>
                <td>
                    <button pButton pRipple label="Merge" icon="pi pi-code-merge" class="p-button-warning" (click)="mergeDuplicate(row)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center p-4 text-500">No duplicate leads found.</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
